import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useLang } from '../lib/i18n';
export function Verify() {
    const { T } = useLang();
    const { setUser } = useAuth();
    const [params] = useSearchParams();
    const token = params.get('token');
    const navigate = useNavigate();
    const [err, setErr] = useState('');
    const next = params.get('next') || '/trips';
    const ran = useRef(false);
    useEffect(() => {
        if (!token) {
            setErr(T('連結無效', '链接无效'));
            return;
        }
        if (ran.current)
            return;
        ran.current = true;
        (async () => {
            try {
                const { user } = await api.post('/auth/verify', { token });
                setUser(user);
                navigate(next, { replace: true });
            }
            catch (e) {
                setErr(e instanceof ApiError ? e.message : T('驗證失敗', '验证失败'));
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    return (_jsx("div", { className: "tt-page", style: { maxWidth: 520, paddingTop: 80 }, children: _jsx("div", { className: "tt-card tt-section", children: err ? (_jsxs(_Fragment, { children: [_jsx("h2", { style: { fontSize: 22 }, children: T('驗證失敗', '验证失败') }), _jsx("p", { style: { color: 'var(--ink-500)', fontSize: 14 }, children: err }), _jsx("a", { href: "/login", className: "tt-btn ghost", style: { alignSelf: 'flex-start' }, children: T('重新登入', '重新登录') })] })) : (_jsx("div", { className: "tt-load", children: T('驗證中…', '验证中…') })) }) }));
}
